export default function removeEmptyKeys(object: any) {
  const obj = { ...object };

  if (typeof obj === "object") {
    for (const key in obj) {
      if (obj[key] === null || obj[key] === undefined) {
        delete obj[key];
      } else if (typeof obj[key] === "object") {
        removeEmptyKeys(obj[key]);
      }
    }
  }

  return obj;
}
